"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const FolderAdd = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.416 3.554a.607.607 0 00-.602.611c0 .182.146.33.325.33h9.722c.179 0 .324-.148.324-.33a.607.607 0 00-.602-.611H2.416zM1.213.167h3.246c.206 0 .405.073.563.207l.725.614c.092.077.207.12.326.12h6.714c.486 0 .88.4.88.893v4.832a5 5 0 00-5 5H1.213c-.486 0-.88-.4-.88-.893V1.06c0-.493.394-.893.88-.893zm11.62 9.166a.833.833 0 011.667 0V11h1.667a.833.833 0 010 1.667H14.5v1.666a.833.833 0 11-1.667 0v-1.666h-1.666a.833.833 0 110-1.667h1.666V9.333z",
  fill: "#1973E8",
  className: "fill"
}));

var _default = FolderAdd;
exports.default = _default;